module.exports = __webpack_public_path__ + "img/sifast_img_en.df84b09f.png";